import { render, staticRenderFns } from "./modalReativarMaterial.vue?vue&type=template&id=1cd92fdc&scoped=true&"
import script from "./modalReativarMaterial.vue?vue&type=script&lang=js&"
export * from "./modalReativarMaterial.vue?vue&type=script&lang=js&"
import style0 from "./modalReativarMaterial.vue?vue&type=style&index=0&id=1cd92fdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd92fdc",
  null
  
)

export default component.exports